import { Component, OnInit, ViewChild } from '@angular/core';
import { CandidateService } from '../../service/candidate/candidate.service';
import { Candidate } from '../../class/candidate';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Message, ConfirmationService, LazyLoadEvent } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';
import { CandidateEducationLevelOptions } from '../../../../shared/constans';

@Component({
  selector: 'app-candidates-synergo',
  templateUrl: './candidates-synergo.component.html',
  styleUrls: ['./candidates-synergo.component.scss']
})

export class CandidatesSynergoComponent implements OnInit {
  @ViewChild('gb') searchFilter;

  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public candidate: Candidate[];
  public selectCandidate: Candidate;
  public candidateID: Number = 0;
  public modNew = false;
  public modView = false;
  public modViewDialog = false;
  public openCandidate = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public with: string;
  public with_count: string;
  public candidatePosition: string;
  public filters: { key: string, value: string }[];
  public modExportDialog: boolean;
  public form4: FormGroup;
  public f4_date_start: AbstractControl;
  public f4_date_end: AbstractControl;
  public f4_candidate_source: AbstractControl;
  public apiUrl = config.API_ROOT;
  public es: any;
  public loading: boolean = true;
  public first = 0;
  public form_filter: FormGroup;
  public form: FormGroup;
  public read: AbstractControl;
  public modNewViewDialog = false;
  public barcodeRead: string;
  // public genderOptions: any[];
  // public civilStatusOptions: any[];
  // public drivingLicenseOptions: any[];
  // public levelEducationOptions: any[] = CandidateEducationLevelOptions;
  // public SMMLV: number = 1300000;
  // public salaryAspirationOptions: any[];
  // public ageMinOptions: any[];
  // public ageMaxOptions: any[];
  // public ageMin: number = 18;
  // // public ageMax: number = 70;
  // public createdByBotzyOptions: any[];
  // public candidateSourceOptions: any[];
  // public employee_id_botzy: string = '11178';
  // public jobStatusOptions: any[];
  // public candidateHasUserOptions: any[];
  // public candidateHasWorkExperienceOptions: any[];

  constructor(
    public candidateService: CandidateService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    public router: Router,
    public fb: FormBuilder
  ) {
    this.modExportDialog = false;
    this.form4 = fb.group({
      'f4_date_start': ['', [Validators.required]],
      'f4_date_end': ['', [Validators.required]],
      'f4_candidate_source': [''],
    });
    this.f4_date_start = this.form4.controls['f4_date_start'];
    this.f4_date_end = this.form4.controls['f4_date_end'];
    this.f4_candidate_source = this.form4['f4_candidate_source'];

    this.es = calendarES();

    this.form = fb.group({
      'read': ['', Validators.compose([Validators.minLength(1)])],
    });
    this.read = this.form.controls['read'];
  }

  ngOnInit() {
    // if (this.route.snapshot.url[0].path === 'management-claro')  {
    //     if (this.route.snapshot.url[1].path === 'auxiliar')  {
    //         this.candidatePosition = '2';
    //         this.filters = [];
    //         this.filters.push({key: 'candidate_position_id', value: this.candidatePosition});
    //     }
    // } else {
    //     if (this.route.snapshot.url[0].path === 'selection')  {
    //         if (this.route.snapshot.url[1].path === 'psychologist')  {
    //             this.candidatePosition = '3';
    //             this.filters = [];
    //             this.filters.push({key: 'candidate_position_id', value: this.candidatePosition});
    //         }
    //     }
    // }
    this.query = undefined;
    this.page = 1;
    this.per_page = 10;
    this.with_count = 'education,work_experience,candidate_comment';
    this.with = 'residence_city_name,profession_name';
    // this.with +='citation.document_profile_survey,citation.requisition_candidate.company,citation.requisition_candidate.profile_survey,citation.requisition_candidate.venue';

    // this.sort = '-id';
    this.sort = '-updated_at';

    // this.getCandidate(this.query);

    this.createFormFilter(null);
  }

  createFormFilter(data: any = null) {
    data = data || {
      candidate_id_filter: '',
    };

    this.form_filter = this.fb.group({
      candidate_id_filter: new FormControl(data.candidate_id_filter),
    });
  }

  public loadCandidateLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;
    if (event.sortField) {
      if (event.sortOrder === -1) {
        this.sort = '-' + event.sortField;
      } else {
        this.sort = event.sortField;
      }
    } else {
      this.sort = '-updated_at';
    }

    this.buildingFilter(this.form_filter.value);
    this.getCandidate(event.globalFilter);
  }

  getCandidate(query?: string) {
    this.loading = true;
    this.candidateService.getCandidate(this.page, this.per_page, this.sort, query, this.filters, this.with, this.with_count).toPromise().then(
      response => {
        this.loading = false;
        this.candidate = response.json().data;
        if (response.json().meta.total > response.json().meta.total_filtered) {
          this.totalRecords = response.json().meta.total_filtered;
        } else {
          this.totalRecords = response.json().meta.total;
        }
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public newCandidate() {
    this.modNew = !this.modNew;
    this.selectCandidate = null;
  }

  public savedCandidate(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectCandidate = null;
    this.modNew = false;
    // this.getCandidate();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public cancelCandidate(res) {
    this.selectCandidate = null;
    this.modNew = false;
    this.modView = false;
    //this.getCandidate();//Comentado porque existe componente y se quita y detecta load_lazy
  }

  public edit(candidate: Candidate) {
    this.modNew = true;
    this.selectCandidate = candidate;
    this.getCandidate();
  }

  public view(candidate: Candidate) {
    this.openCandidate = true;
    this.selectCandidate = candidate;
    this.candidateID = candidate.id;
    this.modView = true;
  }

  public viewDialog(candidate: Candidate) {
    this.openCandidate = true;
    this.selectCandidate = candidate;
    this.candidateID = candidate.id;
    this.modViewDialog = true;
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }
  public exportReportExcel(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url = this.apiUrl + '/candidates/excel?' +
      'token=' + localStorage.getItem('token') +
      '&_page=1&_limit=100000&_sort=-id' +
      '&created_at-min=' + f4_date_start + '&created_at-max=' + f4_date_end;

    if (values.f4_candidate_source) {
      url = url + '&created_by_botzy=' + values.f4_candidate_source + '&';
    }

    window.open(url, '_blank');
  }

  public deleteDialog(candidate: Candidate) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'fa fa-trash',
      accept: () => {
        this.delete(candidate);
      }
    });
  }

  public delete(candidate: Candidate) {
    this.candidateService.deleteCandidate(candidate.id).toPromise().then(
      response => {
        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'deleted' });
        this.getCandidate();
      },
      error => {
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'error' });
      }
    );
  }

  public activeCandidate(candidate: Candidate) {
    this.putCandidate(candidate);
  }

  public putCandidate(values: Candidate) {
    const param = {
      'activated': values.activated
    };
    if (values) {
      const promise = this.candidateService.updateCandidate(values.id, param);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: res });
          });
        },
        error => {
          this.msgs.push({ severity: 'error', summary: 'Error' });
        }
      );
    }
  }

  // public filter(values) {
  //   this.page = 1;
  //   this.first = 0;

  //   var query = this.searchFilter.nativeElement.value;
  //   if (query != null && query != "")
  //     query = query.replace(/\s/g, "%");

  //   // if (values.age_min_filter === null || values.age_min_filter === '' || values.age_min_filter === undefined)
  //   //     values.age_min_filter = this.ageMin;

  //   // if (values.age_max_filter === null || values.age_max_filter === '' || values.age_max_filter === undefined)
  //   //     values.age_max_filter = this.ageMax;

  //   this.buildingFilter(values);

  //   this.getCandidate(query);
  // }

  public buildingFilter(values) {
    this.filters = [];

    this.filters.push({ 'key': 'business_id', 'value': '2' });

    if (values.candidate_id_filter.id !== null && values.candidate_id_filter.id !== '' && values.candidate_id_filter.id !== undefined)
      this.filters.push({ 'key': 'candidate_id', 'value': values.candidate_id_filter.id });
  }

  public getDateFromAge(age_data: number, end_day: boolean, gap_year: number) {
    let date = new Date();
    let today_year = date.getFullYear();

    let year_in_past = today_year - age_data;

    date.setFullYear(year_in_past - gap_year);
    if (end_day)
      date.setHours(23, 59, 59, 999);
    else
      date.setHours(0, 0, 0, 0);

    return formatDate(date);
  }

  public gotoCandidateComments(id) {
    this.router.navigate(['/pages/selection/candidate-comments'], { queryParams: { id_candidate: id } });
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public closeCandidateDialog() {
    this.modNewViewDialog = false;
    this.read.setValue('');
    this.barcodeRead = '';
  }

  public paserRead(values) {
    this.barcodeRead = values.read;
    this.modNewViewDialog = true;
  }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidates-synergo/candidates-synergo.component.ts